<template>
  <div id="notes_create" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
            <span class="page-title" id="termHeader" v-if="$route.params.id > 0">Update Notes</span>
            <span class="page-title" id="termHeader" v-else>Add Notes</span>
            <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackNotesList" >
                <i class="fp-back"> </i> Back
            </button>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content term-crud">
            <section class="internal-container border-top-table-fl">
              <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="NotesForm">
                <div class="form-row row-cols-md-3 row-cols-1">
                  <div class="col form-group">
                      <label class="control-label require" for="subject">Subject:</label>
                      <input type="text" class="form-control" v-model="subject" id="subject" placeholder="Enter Subject" name="subject">
                      <div class="field-error">{{subject_error_msg}}</div>
                  </div>
                  <div class="col form-group">
                      <label class="control-label" for="work_order_id" >Work Order:</label>
                      <v-select v-model="work_order_id" name="work_order_id"
                          label="text" :filterable="false" :options="workOrderArr"
                          @search="onSearchWorkOrder"
                          placeholder="Select Work Order" class="custom-ci-auto-search">
                          <template slot="no-options">
                              Search Work Order...
                          </template>
                          <template slot="option" slot-scope="option">
                              <div class="d-center">
                                  {{ option.text }}
                              </div>
                          </template>
                          <template slot="selected-option" slot-scope="option">
                              <div class="selected d-center">
                                  {{ option.text }}
                              </div>
                          </template>
                      </v-select>
                  </div>
                  <div class="col form-group">
                      <label class="control-label" for="vehicle_id" >Asset:</label>
                      <v-select v-model="vehicle_id" name="vehicle_id"
                          label="text" :filterable="false" :options="vehicleArr"
                          @search="onSearchVehicle"
                          placeholder="Select Asset" class="custom-ci-auto-search">
                          <template slot="no-options">
                              Search Asset...
                          </template>
                          <template slot="option" slot-scope="option">
                              <div class="d-center">
                                  {{ option.text }}
                              </div>
                          </template>
                          <template slot="selected-option" slot-scope="option">
                              <div class="selected d-center">
                                  {{ option.text }}
                              </div>
                          </template>
                      </v-select>
                  </div>
                </div>
                <div class="form-row row-cols-md-1 row-cols-1">
                    <div class="col form-group">
                        <label class="control-label require" for="description">Description:</label>
                        <textarea rows="4" class="form-control" v-model="description" id="description" placeholder="Enter Description" name="description"></textarea>
                        <div class="field-error">{{description_error_msg}}</div>
                    </div>
                </div>
                <div class="btn-groups">
                    <button type="submit" id="CreateNotesBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateNotes" >
                    <i class="fp-reload"> </i>  Update
                    </button>
                    <button type="submit" id="CreateNotesBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateNotes" >
                    <i class="fp-save"> </i>  Save
                    </button>
                    <button type="submit" id="cancelNotesBtn" class="btn btn-tertiary" v-on:click.prevent="BackNotesList" >
                    <i class="fp-close"> </i>  Cancel
                    </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
          <div class="container-fluid">
              <div class="bg-white text-center">
                  <h1>
                      Oops!</h1>
                  <h2>
                      403 </h2>
                  <div class="error-details">
                      Sorry!, You don't have permission to access this page.
                  </div>
              </div>
          </div>
      </template>
      <template v-else>
          <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

export default {
  name: "NotesCreate",
  
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Notes | " +process.env.COPYRIGHT_NAME : "Create Notes | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    subject: "",
    workOrderArr:[],
    work_order_id:null,
    vehicleArr:[],
    vehicle_id:null,
    description: "",
    loading:false,
    subject_error_msg: "",
    description_error_msg: "",
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_notes') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }
  },
  created: function() {

  },
  mounted: function() {
      var self = this;
      self.getPermissions();

      setTimeout(function () {
          var path = window.location.pathname;
          var segments = path.split("/");

          if (segments[3]) {
              self.loadNotes();
          }
      }, 100);
  },
  methods: {
    BackNotesList() {
      var self = this;
      self.$router.push("/notes/list");
    },
    onSearchVehicle(search, loading) {
        var self = this;

        if (search.length > 3) {
            self.searchField(loading, search, 'vehicle');
        }

    },
    onSearchWorkOrder(search, loading) {
        var self = this;

        if (search.length > 2) {
            self.searchField(loading, search, 'work_order');
        }

    },
    CreateNotes() {

      var self = this;

      self.subject_error_msg = "";
      self.description_error_msg = "";

      if (!self.subject || self.subject == null || self.subject == "") {
        self.subject_error_msg = "Subject Required.";
      }

      if (!self.description || self.description == '' || self.description == "") {
        self.description_error_msg = "Description Required.";
      }

      if (self.subject_error_msg == "" && self.description_error_msg == ""){
        self.loading = true;
        var path = window.location.pathname;
        var segments = path.split("/");
        if (segments[3]){
          $("#CreateNotesBtn").val("Updating ...");
          $("#CreateNotesBtn").prop("disabled", true);
          $("#cancelNotesBtn").prop("disabled",true);
        }else{
          $("#CreateNotesBtn").val("Saving ...");
          $("#CreateNotesBtn").prop("disabled", true);
          $("#cancelTermBtn").prop("disabled",true);
        }
        var fields = $("#NotesForm").serializeArray();
        if(self.vehicle_id == null){
            fields.push({name: "vehicle_id", value: null});
        }else{
            fields.push({name: "vehicle_id", value: self.vehicle_id.value});
        }
        if(self.work_order_id == null){
            fields.push({name: "work_order_id", value: null});
        }else{
            fields.push({name: "work_order_id", value: self.work_order_id.value});
        }
        fields.push({name: "id", value: segments[3]});
        fields.push({name: "subject", value: self.subject});
        fields.push({name: "description", value: self.description});
        $.ajax({
                url: process.env.ROOT_API + "/notes/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                  self.loading = false;
                  if (segments[3]){
                    $("#CreateNotesBtn").val("Update");
                    $("#CreateNotesBtn").prop("disabled", false);
                    $("#cancelNotesBtn").prop("disabled",false);
                  } else {
                    $("#CreateNotesBtn").val("Save");
                    $("#CreateNotesBtn").prop("disabled", false);
                    $("#cancelNotesBtn").prop("disabled",false);
                  }
                  if (data.status == "success") {

                    self.$router.push("/notes/list");

                  }else{
                    if (data.content.length > 0) {
                        var err = "";
                        for (var i = 0; i < data.content.length; i++) {
                            err += data.content[i] + "<br>";
                        }
                        $("#errorMsg").html(err);
                        $(".alert-warning").toggleClass("show");
                        setTimeout(function () {
                            $(".alert-warning").removeClass("show");
                            $(".alert-warning").addClass("hide");
                        }, 10000);
                    }
                  }
                },
                error: function (jqXHR, exception) {
                  self.loading = false;
                  if (segments[3])
                  {
                      $("#CreateNotesBtn").val("Update");
                      $("#CreateNotesBtn").prop("disabled", false);
                      $("#cancelNotesBtn").prop("disabled",false);
                  } else {
                      $("#CreateNotesBtn").val("Save");
                      $("#CreateNotesBtn").prop("disabled", false);
                      $("#cancelNotesBtn").prop("disabled",false);
                  }
                  self.generateStatusCodeMessage(jqXHR,true,'note-create')
                }
        });
      }else{
        self.errorValidationFocus();
      }

    },
    loadNotes() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
           url: process.env.ROOT_API + "/notes/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
              self.loading = false;
              console.log(data);
              if (data.status == "success") {
                  self.subject = data.content.subject;
                  self.description = data.content.description;
                  if (data.content.vehicle_id != null) {
                      self.vehicle_id = {value: data.content.vehicle_id, text: data.content.vehicle};
                  } else {
                      self.vehicle_id = null;
                  }
                  if (data.content.work_order_id != null) {
                      self.work_order_id = {value: data.content.work_order_id, text: data.content.work_order};
                  } else {
                      self.work_order_id = null;
                  }

              }

            },
            error: function (jqXHR, exception) {
              self.loading = false;
              self.generateStatusCodeMessage(jqXHR,false,'notes-load-by-id')
            }
        })
    }


  },
};


</script>




// WEBPACK FOOTER //
// src/components/NotesCreate.vue